import React, { useEffect, useState } from "react";
import { Table, Button, Space } from "antd";
import { formatToCompanyTimezone, getAccessType } from "../../../lib/functions";

const CustomerPendingTable = ({
  list,
  loading,
  printMode = false,
  onAdd,
  onView,
  onApprove,
  onReject,
}) => {
  let [access_type, access_type_set] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const access = getAccessType("pending_customer_list");
    access_type_set(access);
  }, []);

  const columns = [
    { title: "No.", dataIndex: "no", width: 60 },
    { title: "Customer Name", dataIndex: "acc_name" },
    { title: "Contact No", dataIndex: "contact_no" },
    { title: "Profession", dataIndex: "profession" },
    { title: "Address", dataIndex: "address" },
    { title: "Area", dataIndex: "area" },
    { title: "Expectation %", dataIndex: "expectation_per" },
    { title: "Email Address", dataIndex: "email_address" },
    { title: "Date", dataIndex: "date", render: (v) =>
    v ? formatToCompanyTimezone(v).split(" ")[0] : "-", },
    !printMode && {
      title: "Conversation",
      className: "no-print",
      render: (_, record) => (
        <Space>
          {access_type == "WRITE" && (
            <Button
              type="link"
              data-testid={`add-btn-${record.id}`}
              onClick={() => onAdd?.(record)}
            >
              Add
            </Button>
          )}
          <Button
            type="link"
            data-testid={`view-btn-${record.id}`}
            onClick={() => onView?.(record)}
          >
            View
          </Button>
        </Space>
      ),
    },
    {
      title: "Actions",
      className: "no-print",
      render: (_, record) => (
        <Space>
          {access_type == "WRITE" && (
            <>
              <Button
                type="link"
                data-testid={`approve-btn-${record.id}`}
                style={{ color: "green" }}
                onClick={() => onApprove?.(record)}
              >
                Approve
              </Button>
            </>
          )}
          {access_type == "WRITE" && (
            <>
              <Button
                type="link"
                data-testid={`reject-btn-${record.id}`}
                danger
                onClick={() => onReject?.(record)}
              >
                Reject
              </Button>
            </>
          )}
        </Space>
      ),
    },
  ].filter(Boolean);

  return (
    <Table
      rowKey="id"
      dataSource={list}
      columns={columns}
      loading={loading}
      pagination={printMode ? false : {
      current: currentPage,
      pageSize: pageSize,
      total: list.length,
      showQuickJumper: true,
      showSizeChanger: true,
      pageSizeOptions: [10, 20, 50, 100],
      onChange: (page) => {
        setCurrentPage(page);
      },
      onShowSizeChange: (_, size) => {
        setPageSize(size);   
        setCurrentPage(1);   
      },
      }}
      bordered
      size={printMode ? "small" : "middle"}
      scroll={printMode ? undefined : { x: "max-content" }}
    />
  );
};

export default CustomerPendingTable;
